import styled from "styled-components";


export const VideoPlayButtonBox =  styled.button`
    background-image: url("${props => props.theme.images.spriteSheet.toString()}");
    background-position: -544px -409px;
    background-size: 1200px;
    background-repeat: no-repeat;
    position: absolute;
    cursor: pointer;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 6rem;
    height: 6rem;
    opacity: 0.9;
    transform: scale(1.5);
    transform: translateY(0);
    transition: all 0.35s ease-in-out;
`;


